import { z } from 'zod'

export const alertRuleDeviceGroupSchema = z.object({
  deviceGroupId: z.string(),
})

export type TAlertRuleDeviceGroup = z.infer<typeof alertRuleDeviceGroupSchema>

export type TAlertRuleDeviceGroupList = TAlertRuleDeviceGroup[]
